export default __webpack_public_path__ + "static/p1.1_Roman-3e4aafba42a3020eac69f29a7e45f870.wav";